import { render } from "./xmas.component.vue?vue&type=template&id=4cc9d590"
import script from "./xmas.component.vue?vue&type=script&lang=js"
export * from "./xmas.component.vue?vue&type=script&lang=js"

import "./xmas.component.vue?vue&type=style&index=0&id=4cc9d590&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__